module.exports = __webpack_public_path__ + "img/f6-2-1.24158f77.png";